import React, {useEffect} from 'react';
import errorActions from '../../actions/error.actions';
import Snackbar from '@material-ui/core/Snackbar';
import {useHistory} from 'react-router';
import {useDispatch, useSelector} from 'react-redux';
import {transformError} from '../../utils/ErrorUtils';
import {makeStyles} from '@material-ui/core';
import {withLocalization} from 'epic-localization/src/context/LocalizationContext';
import {generateRoutePath} from '@epic-core/common';
import {Alert} from '../';
import {ErrorCode} from '../../../shared/types';
import {selectAffiliateId, selectError, selectQuickLinks, selectIsLoggedIn} from '../../selectors';

const useStyles = makeStyles(theme => ({
    root: {
        flexDirection: 'row'
    },
    snackbar: {
        [theme.breakpoints.up('lg')]: {
            width: '70%'
        }
    },
    alert: {
        [theme.breakpoints.up('lg')]: {
            width: '100%'
        }
    }
}));

interface AppErrorAlert {
    messages: Record<string, string>;
    getMessage: (code: string, args?: any[]) => string;
}

const AppErrorAlert: React.FC<AppErrorAlert> = ({getMessage}) => {
    const styles = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const errorState = useSelector(selectError);
    const quickLinks = useSelector(selectQuickLinks);
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const affiliateId = useSelector(selectAffiliateId);

    useEffect(() => {
        history.listen((location, action) => {
            dispatch(errorActions.hideErrorMessage());
        });

        if (isLoggedIn && !affiliateId) {
            return history.push(generateRoutePath('/unexpected-error'), {
                errorCode: ErrorCode.CONTACT_SUPPORT,
                args: [quickLinks.contactSupport]
            });
        }
    }, []);

    const error = transformError(errorState, {quickLinks});
    const onClose = () => dispatch(errorActions.hideErrorMessage());

    return (
        <Snackbar
            className={styles.snackbar}
            key={error.errorCode}
            open={errorState.show}
            onClose={onClose}
            autoHideDuration={10000}>
            <Alert
                className={styles.alert}
                classes={{root: styles.root}}
                elevation={6}
                type="ERROR"
                severity="error"
                variant="filled"
                message={getMessage(error.errorCode, error.messageVars)}
                onClose={onClose}
                closeable
                html
            />
        </Snackbar>
    );
};

export default withLocalization(AppErrorAlert);
